import { render, staticRenderFns } from "./AdminUpdateExerciseLaws.vue?vue&type=template&id=5f9c9057&scoped=true"
import script from "./AdminUpdateExerciseLaws.vue?vue&type=script&lang=js"
export * from "./AdminUpdateExerciseLaws.vue?vue&type=script&lang=js"
import style0 from "./AdminUpdateExerciseLaws.vue?vue&type=style&index=0&id=5f9c9057&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c9057",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9c9057')) {
      api.createRecord('5f9c9057', component.options)
    } else {
      api.reload('5f9c9057', component.options)
    }
    module.hot.accept("./AdminUpdateExerciseLaws.vue?vue&type=template&id=5f9c9057&scoped=true", function () {
      api.rerender('5f9c9057', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminUpdateExerciseLaws.vue"
export default component.exports